import { useUserSession } from '@solinkcorp/authentication';

export interface DefaultAiTag {
  readonly category: string;
  readonly name: string;
}

export default function useDefaultAiTags(): readonly DefaultAiTag[] {
  const user = useUserSession();
  return user.clientSettings?.defaultAiTags ?? [];
}
